module.exports = __webpack_public_path__ + "img/20170922055753238.b9073b43.jpg";